/**
 * Main Application Bootstrapper
 * Configures global event listeners, authentication state tracking, and layout rendering.
 */

import { checkAuthState, currentUserRole } from './auth.js';
import { router } from './router.js';
import { renderSidebar, initSidebar } from './components/sidebar.js';
import { renderTopbar, initTopbar, destroyTopbar } from './components/topbar.js';
import { hideLoader, showToast } from './utils.js';

let isAppInitialized = false;

// 1. Initial Theme Check
const savedTheme = localStorage.getItem('pharma-crm-theme') || 'light';
document.documentElement.setAttribute('data-theme', savedTheme);

// 2. Main Boot function
function bootstrap() {
  
  // Listen for hash change routing
  window.addEventListener('hashchange', () => {
    router();
  });

  // 3. Network Connection Status Watchers
  window.addEventListener('online', () => {
    showToast("Internet Online", "Database connection restored in real-time.", "success");
  });

  window.addEventListener('offline', () => {
    showToast("Network Offline", "Work will queue locally. Real-time updates paused.", "warning");
  });

  // Track Firebase Auth State
  checkAuthState((user) => {
    if (user) {
      // User is logged in
      console.log(`User logged in: ${user.email} (Role: ${currentUserRole})`);
      
      // Render layout components once if not done yet
      if (!isAppInitialized) {
        renderSidebar();
        initSidebar();
        
        renderTopbar();
        initTopbar();
        
        isAppInitialized = true;
      }
      
      // Execute routing
      router();
    } else {
      // User is logged out
      console.log("No authenticated user.");
      isAppInitialized = false;
      
      destroyTopbar();
      
      // Clear containers
      const sidebarContainer = document.getElementById('sidebar-container');
      const topbarContainer = document.getElementById('topbar-container');
      if (sidebarContainer) sidebarContainer.innerHTML = '';
      if (topbarContainer) topbarContainer.innerHTML = '';
      
      // Execute routing (which forces redirect to #login)
      router();
    }

    // Always hide the splash loader screen once Auth state has resolved
    hideLoader();
  });
}

// Start application
bootstrap();

